import { apiFetch } from './api';
import type { EnvironmentId } from '@/deploy/types';

export interface EnvironmentInstance {
  pteroId: number;
  identifier: string;
  name: string;
  image: string;
  containerCode?: string;
  /**
   * Groupe de jeu du serveur (RECUBE_GROUP, normalisé), même s'il n'est pas un groupe du projet.
   * Absent si la variable est vide, ou si le projet n'a pas les groupes (hors NationsGlory).
   */
  group?: string;
}

export interface EnvironmentInstancesResponse {
  configured: boolean;
  message?: string;
  instances: EnvironmentInstance[];
}

export const environmentsService = {
  /** Liste les serveurs Pterodactyl d'un env. Renvoie configured=false si Ptero pas setup. */
  listInstances: (projectId: string, envId: EnvironmentId) =>
    apiFetch<EnvironmentInstancesResponse>(`/api/projects/${projectId}/environments/${envId}/instances`),
};
